import { useRouter } from 'next/router'
import Link from 'next/link'
import Head from 'next/head'
import { Trans } from '@lingui/macro'
import { FaArrowRight } from 'react-icons/fa'
import H1 from 'components/ui/H1'
import Header from 'components/ui/Header'
import Index from 'components/Index'
import LeadingParagraph from 'components/ui/LeadingParagraph'
import ButtonLink from 'components/ButtonLink'

const RegionIndex = ({ region, posts }) => {
  const { locale } = useRouter()

  return (
    <div className="pb-10">
      <Head>
        <title key="title">
          {`${region.title[locale]} - ${process.env.NEXT_PUBLIC_SITE_TITLE}`}
        </title>
        <meta
          property="og:title"
          content={region.title[locale]}
          key="og:title"
        />
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_DOMAIN}${
            locale == 'en' ? `` : `/${locale}`
          }/regions/${region.slug[locale].current}`}
          key="canonical"
        />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_DOMAIN}${
            locale == 'en' ? `` : `/${locale}`
          }/regions/${region.slug[locale].current}`}
          key="og:url"
        />
      </Head>
      <div className="container">
        <Header>
          <p className="mb-4 text-center font-medium uppercase 2xl:mb-10">
            <Link href="/regions">
              <a>
                <Trans>Region</Trans>
              </a>
            </Link>
          </p>
          <H1>{region.title[locale]}</H1>
        </Header>
        <Index posts={posts} />
        <div className="flex justify-center lg:mt-10">
          <ButtonLink
            href={{
              pathname: '/search',
              query: { region: region._id },
            }}
          >
            <span className="mr-2 leading-tight">
              <Trans>Explore more content</Trans>
            </span>
            <FaArrowRight />
          </ButtonLink>
        </div>
      </div>
    </div>
  )
}
export default RegionIndex
